// @flow

/**
 * Normalize a resource meter reading into a number safe to do arithmetic with.
 *
 * A resource that never had a reading arrives as `null`, and `parseFloat(null)` is `NaN`.
 * `NaN + diff` reaches the server as the string "NaN", which `convertDoubleToMysqlFormat`
 * silently turns into 0.00 — the check-in then records an empty row and leaves the counter
 * NULL, so the next check-in repeats. Treat a missing reading as the 0 the column defaults to.
 */
export default function counterBase(value: mixed): number {
	const parsed = parseFloat(String(value == null ? '' : value).replace(',', '.'));
	return Number.isFinite(parsed) ? parsed : 0;
}
